// extracted by mini-css-extract-plugin
module.exports = {"job":"AllocatedJob_job__3znLU","time":"AllocatedJob_time__1GGjK"};